import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-faq-wrapper1',
  templateUrl: './faq-wrapper1.component.html',
  styleUrls: ['./faq-wrapper1.component.scss']
})
export class FaqWrapper1Component implements OnInit {

  @Input() faqwrapper1Type:string;

  constructor() { }

  ngOnInit(): void {
  }

}
